import { render, staticRenderFns } from "./LiveChatLeftBar.vue?vue&type=template&id=d1f57354&scoped=true"
import script from "./LiveChatLeftBar.vue?vue&type=script&lang=js"
export * from "./LiveChatLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f57354",
  null
  
)

export default component.exports